<template>
  <el-drawer
    :visible.sync="visi"
    :with-header="false"
    direction="ltr"
    size="20rem">
    <div class="logo">
      <img :src="logo" />
    </div>
    <el-scrollbar :native="false">
      <el-menu
        :show-timeout="200"
        :default-active="path"
        mode="vertical"
        @select="path => menuSelect(path)">
        <Items 
          v-for="item in routes" 
          :key="item.path" 
          :menu-item="item" />
      </el-menu>
    </el-scrollbar>
  </el-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import router from '@/router'
import Items from './Items'
import * as NodePath from 'path'
export default {
  props: {
    value: Boolean
  },
  computed: {
    ...mapGetters(['authList', 'userInfo']),
    routes(){
      let cpRoutes = JSON.parse(JSON.stringify(router.options.routes));
      return this.filterRoutes(cpRoutes);
    },
    path(){
      let result = this.$route.path;
      if(result.substr(-1) === '/') result = result.substr(0, result.length - 1)
      return result
    },
    visi: {
      get(){
        return this.value;
      },
      set(val){
        this.$emit('input', val);
      }
    },
    logo(){
      let { logo } = this.userInfo
      return logo || '/static/img/CMK_Logo_white.png'
    }
  },
  components: {
    Items
  },
  methods: {
    filterRoutes(routes, prevPath = ''){
      return routes.map(item => {
        //判断是否需要隐藏
        if(item.hidden) return null;
        //判断权限是否匹配
        let metaAuth = item.meta && item.meta.auth ? item.meta.auth : null;
        if(metaAuth && this.authList.indexOf(metaAuth) == -1)
          return null;
        //设置path
        item.path = NodePath.resolve(prevPath, item.path);
        //是否为root
        item.isRoot = !(item.children && item.children.length);
        //过滤子项
        if(!item.isRoot)
          item.children = this.filterRoutes(item.children, item.path);
        //alwaysShow
        if(!item.alwaysShow && 
          item.children && 
          item.children.length == 1){
          item = {...item.children[0], meta: { ...item.meta, ...item.children[0].meta }};
        }
        //是否有root
        if(!item.isRoot && (!item.children || !item.children.length))
          return null
        return item;
      }).filter(item => item ? true: false)
    },
    menuSelect(path){
      /^(https?:|mailto:|tel:)/.test(path)
      ? window.open(path, 'blank').location
      : this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
$sidebar-bgi: #444348;
$sidebar-open-bgi: darken($sidebar-bgi, 10%);
$sidebar-active-bgi: #1890FF;
>>> .el-drawer__body{
  background-color: #444348;
  display: flex;
  flex-direction: column;
  .logo{
    padding: 1.75rem 0 1.225rem 0.875rem;
    box-sizing: content-box;
    img{
      display: block;
      width: auto;
      height: 3.5rem;
    }
  }
  .el-scrollbar{
    flex: 1;
    .el-scrollbar__wrap{
      .el-menu{
        background-color: $sidebar-bgi;
        border-right: 0;
        .el-menu-item,
        .el-submenu__title{
          color: #ccc;
          transition: color .28s;
          .svg-icon{
            vertical-align: sub;
            margin-right: 0.35rem;
          }
          &:hover{
            background-color: unset;
            span,
            a,
            .svg-icon{
              color: #ffffff;
            }
          }
        }
        .el-submenu{
          &.is-opened{
            .el-menu{
              background-color: $sidebar-open-bgi;
            }
          }
        }
        .el-menu-item{
          &.is-active{
            background-color: $sidebar-active-bgi;
            color: #FFF;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Sidebar/index.vue